import { createGlobalStyle } from 'styled-components';

import '@ingka/core/dist/style.css';
import '@ingka/svg-icon/dist/style.css';
import '@ingka/button/dist/style.css';
import '@ingka/modal/dist/style.css';
import '@ingka/focus/dist/style.css';
import '@ingka/product-identifier/dist/style.css';
import '@ingka/avatar/dist/style.css';
import '@ingka/segmented-control/dist/style.css';

const GlobalStyles = createGlobalStyle`
  html {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    touch-action: pan-x pan-y;
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
    -webkit-tap-highlight-color: transparent;
  }

  body {
    height: 100%;
    width: 100%;
    padding: 0;
    margin: 0;
    font-family: 'notoIKEAlatin','Noto Sans','Roboto','Open Sans',sans-serif;
    -webkit-font-smoothing: antialiased;
    -webkit-touch-callout: none !important;
  }

  /*
    This will hide the focus indicator if the element receives focus via the mouse,
    but it will still show up on keyboard focus.
  */
  .js-focus-visible :focus:not(.focus-visible) {
    outline: none;
  }

  .ws-selector.cx-desktop,
  .cx-widget,
  .cx-widget.cx-common-container.cx-webchat.cx-close.cx-minimize.cx-theme-ikea.cx-desktop.cx-transcript-view,
  .cx-widget cx-window-manager cx-theme-ikea cw-webchat {
    z-index: 3000 !important;
  }

  .virtualKeyboard {
    position: absolute;
  }

  .no-print {
    display: none !important;
  }

  .prompt__heading{
    margin-top: 0;
  }

  /** Skapa card override, remove this and our landing page cards will not be looking fine
      Kvadrat has updated a package that loads a later version of another skapa package that includes some
      css overrides that breaks our styles for the landing page for some reason
  */
  .card.card--emphasised.card--compact {
    flex-direction: column;
  }

  .modal-wrapper__backdrop--dark {
    background-color: rgba(0, 0, 0, 0.15) !important;
  }

  /** Skapa sheet override, to make sure sheets appear to the right regardles of local (LTR/RTL) */
  .sheets {
    right: 0px !important;
    animation: modalSlideToRight cubic-bezier(0, 0, 0.1, 1) 200ms !important;

  }
  .sheets.sheets--enter {
    animation: modalSlideToLeft cubic-bezier(0, 0, 0.1, 1) 200ms !important;
  }
`;

export default GlobalStyles;
